export function getAssigneeName(assignee) {
  if (!assignee) {
    return 'Assignee'
  }
  return assignee
}
